import { scroll, animate } from 'vendor';

(function () {
  if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;

  document.querySelectorAll('[data-parallax]').forEach(function (container) {
    var intensity = parseFloat(container.getAttribute('data-parallax')) || 0.3;
    var media = Array.from(container.querySelectorAll(':scope > :is(img, picture, video, svg, video-media)'));
    if (!media.length) return;

    var scale = 1 + intensity;
    var translate = (intensity * 100) / scale;

    scroll(
      animate(media, {
        transform: [
          'scale(' + scale + ') translateY(-' + translate + '%)',
          'scale(' + scale + ') translateY(0)'
        ]
      }, { easing: 'linear' }),
      { target: container, offset: ['start end', 'end start'] }
    );
  });
})();
